export const VENDOR_PROJECT_AI_SUPPORTED_FILE_EXTENSIONS = [
    '.pdf',
    '.docx',
    '.txt',
    '.md',
    '.html',
    '.htm',
]

export const VENDOR_PROJECT_AI_FILE_TYPES = {
    'application/pdf': ['.pdf'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        '.docx',
    ],
    'text/plain': ['.txt'],
    'text/markdown': ['.md'],
    'text/html': ['.html', '.htm'],
}

export const VENDOR_PROJECT_AI_MAX_FILE_SIZE = 10 * 1024 * 1024
export const VENDOR_PROJECT_AI_MIN_DESCRIPTION_LENGTH = 20
export const VENDOR_PROJECT_AI_MAX_DESCRIPTION_LENGTH = 20000

export const CREATE_PROJECT_MODAL_HEIGHT = 'min(860px, calc(100vh - 96px))'
export const MY_PROJECTS_BODY_HEIGHT =
    'clamp(260px, calc(100vh - 430px), 720px)'
